import React from "react";
import { ThreeCircles } from 'react-loader-spinner'

export default function Loader() {
    return (
        <div style={{
            display: 'grid',
            placeItems: 'center',
            height: '70vh'
        }}>
            <ThreeCircles
                height="80"
                width="80"
                radius="9"
                color="navy"
                ariaLabel="loading"
            />
        </div>


    );
}
